// Pfad der öffentlichen Platzseite: lesbarer Name, sonst Nummer (die Nummer leitet auf den Namen weiter).
// Zwilling von lib/slug.js spotPath (Gleichheit per Test).
export const spotPath = (spot) => '/spot/' + (spot && spot.slug ? spot.slug : spot && spot.id);
